import React, { createContext, useState } from "react";
import { INVOICE_PLAN_SYSCODE } from "../../../constants/invoice_plan_syscode";
import { INVOICE_SYSCODE } from "../../../constants/invoice_syscode";

const tabs = [
  { name: "Certification (UAT)", invoicePlanSyscode: INVOICE_PLAN_SYSCODE.Staging, invoiceSyscode: INVOICE_SYSCODE.Certification },
  { name: "Certification (Go Live)", invoicePlanSyscode: INVOICE_PLAN_SYSCODE.Production, invoiceSyscode: INVOICE_SYSCODE.Certification },
  { name: "Staging", invoicePlanSyscode: INVOICE_PLAN_SYSCODE.Staging, invoiceSyscode: INVOICE_SYSCODE.Project },
  { name: "Production", invoicePlanSyscode: INVOICE_PLAN_SYSCODE.Production, invoiceSyscode: INVOICE_SYSCODE.Project },
  { name: "Tech Support", invoicePlanSyscode: INVOICE_PLAN_SYSCODE.Staging, invoiceSyscode: INVOICE_SYSCODE.Tech_Support },
];

// For mobile, you might want to use shorter names
const mobileTabs = [
  { name: "Cert (UAT)", fullName: "Certification (UAT)", invoicePlanSyscode: INVOICE_PLAN_SYSCODE.Staging, invoiceSyscode: INVOICE_SYSCODE.Certification },
  { name: "Cert (Live)", fullName: "Certification (Go Live)", invoicePlanSyscode: INVOICE_PLAN_SYSCODE.Production, invoiceSyscode: INVOICE_SYSCODE.Certification },
  { name: "Staging", fullName: "Staging", invoicePlanSyscode: INVOICE_PLAN_SYSCODE.Staging, invoiceSyscode: INVOICE_SYSCODE.Project },
  { name: "Production", fullName: "Production", invoicePlanSyscode: INVOICE_PLAN_SYSCODE.Production, invoiceSyscode: INVOICE_SYSCODE.Project },
  { name: "Tech Support", fullName: "Tech Support", invoicePlanSyscode: INVOICE_PLAN_SYSCODE.Staging, invoiceSyscode: INVOICE_SYSCODE.Tech_Support },
];

export const pricingPlanTabContext = createContext();
export const pricingPlanCurrentTabContext = createContext();

export const PricingPlanContextProvider = ({ children }) => {
  const [currentTab, setCurrentTab] = useState(tabs[0]);

  const setTab = (tab) => {
    setCurrentTab(tab);
  };

  const setTabByValue = (invoicePlanSyscode, invoiceSyscode) => {
    const tab = tabs.find(
      (t) => t.invoicePlanSyscode === invoicePlanSyscode && t.invoiceSyscode === invoiceSyscode
    );
    if (tab) {
      setCurrentTab(tab);
    }
  };

  return (
    <pricingPlanTabContext.Provider value={{ tabs, mobileTabs }}>
      <pricingPlanCurrentTabContext.Provider value={{ currentTab, setTab, setTabByValue }}>
        {children}
      </pricingPlanCurrentTabContext.Provider>
    </pricingPlanTabContext.Provider>
  );
};